import { render, staticRenderFns } from "./AddInternalInformation.vue?vue&type=template&id=b29cebe6&"
import script from "./AddInternalInformation.vue?vue&type=script&lang=ts&"
export * from "./AddInternalInformation.vue?vue&type=script&lang=ts&"
import style0 from "./AddInternalInformation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddInternalInformation.vue"
export default component.exports